import { PaperCard } from "@/components/ui/paper-card";
import { Kicker } from "@/components/ui/kicker";
import { PersonaVoice } from "@/components/ui/persona-voice";
import { SituationNarrative } from "@/components/experience/situation-narrative";
import { cn } from "@/lib/utils";

export interface WorkspaceSidebarSituationProps {
  personaName?: string | null;
  personaBrief?: string | null;
  scenarioNarrative?: string | null;
}

export function WorkspaceSidebarSituation({
  personaName,
  personaBrief,
  scenarioNarrative,
}: WorkspaceSidebarSituationProps) {
  if (!personaBrief && !scenarioNarrative) {
    return null;
  }

  return (
    <PaperCard className="p-5 space-y-4 border border-border/80">
      <Kicker as="h3">Situation brief</Kicker>
      {personaBrief && (
        <div className="space-y-1.5">
          <span className="text-xs font-semibold text-muted-foreground">
            {personaName
              ? `${personaName.split(" ")[0]}'s brief`
              : "First-person brief"}
          </span>
          <PersonaVoice size="base" className="leading-relaxed">
            “{personaBrief.trim().replace(/^["“]|["”]$/g, "")}”
          </PersonaVoice>
        </div>
      )}
      {scenarioNarrative && (
        <div
          className={cn(
            "space-y-1.5",
            personaBrief && "border-t border-border/60 pt-3",
          )}
        >
          <span className="text-xs font-semibold text-muted-foreground">
            Scenario narrative
          </span>
          <SituationNarrative>{scenarioNarrative}</SituationNarrative>
        </div>
      )}
    </PaperCard>
  );
}
